import { motion } from "framer-motion"
import { RiArrowRightLine } from "@remixicon/react"
import { Link } from "react-router-dom"

import { ColorBand, ColorBandInner } from "@/components/landing/ColorBand"
import { MarketingPageShell } from "@/components/landing/MarketingPageShell"
import {
  inView,
  staggerContainer,
  staggerItem,
} from "@/components/landing/marketing-motion"
import { products, type ProductSlug } from "@/content/product"

const slugs: ProductSlug[] = ["sales-link", "sell", "grow", "connect"]

const cardTones = [
  "bg-[#d2e4c4]",
  "bg-[#d4c4fc]",
  "bg-[#efe04a]",
  "bg-white",
] as const

export function ProductIndexPage() {
  return (
    <MarketingPageShell
      eyebrow="Product"
      title="Everything under your sales link"
      description="Your storefront, checkout, insight, and customer tools, built as one product you share with a single URL."
      heroVariant="sage"
      bare
    >
      <ColorBand className="bg-[#f6f4ef] text-primary">
        <ColorBandInner>
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={inView}
            className="grid gap-5 md:grid-cols-2"
          >
            {slugs.map((slug, i) => {
              const p = products[slug]
              return (
                <motion.article
                  key={slug}
                  variants={staggerItem}
                  className="group flex flex-col overflow-hidden rounded-[2.5rem] bg-white"
                >
                  <div className="aspect-16/10 overflow-hidden">
                    <img
                      src={p.image}
                      alt=""
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                    />
                  </div>
                  <div
                    className={`flex flex-1 flex-col p-7 sm:p-8 ${cardTones[i]}`}
                  >
                    <p className="font-heading text-xs uppercase tracking-wider text-primary/60">
                      {p.tagline}
                    </p>
                    <h2 className="font-heading mt-2 text-xl text-primary sm:text-2xl">
                      {p.title}
                    </h2>
                    <p className="mt-3 line-clamp-3 flex-1 text-sm font-semibold leading-relaxed text-primary/65">
                      {p.intro}
                    </p>
                    <Link
                      to={`/product/${slug}`}
                      className="text-major mt-6 inline-flex items-center gap-1 text-sm text-primary hover:underline"
                    >
                      Read more
                      <RiArrowRightLine className="size-4" />
                    </Link>
                  </div>
                </motion.article>
              )
            })}
          </motion.div>
        </ColorBandInner>
      </ColorBand>
    </MarketingPageShell>
  )
}
